import React from 'react';
import Button from 'react-bootstrap/Button';
import "react-datepicker/dist/react-datepicker.css";
import { MdDelete } from "react-icons/md";
import { deleteEmployer } from "../dbconnector/connector.js";
import { useEffect } from 'react';
import { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { setErrorMessage } from '../tools/errorhandling.js';
import { HiOutlineChevronDown } from "react-icons/hi";
import { HiOutlineChevronUp } from "react-icons/hi";
import CurrencyInput from 'react-currency-input-field';



const EmployeeNode = ({ rights, translation, isDisabled, hotelsarray, data, events, displaytabs, disabledtabs, defaulttab, viewOnly }) => {
    const [key, setKey] = useState('home');
    const t = translation

    useEffect(() => {
        console.log("data =", data.employer.id)

    }, [data.employer]);


    function deleteemp() {
        const options = {
            title: t("Delete?"),
            message: t("message_deleteEmployee_1") + data.employer.Naam + t("message_deleteRoom_2"),
            buttons: [
                {
                    label: t("Yes"),
                    onClick: () => {
                        const response = deleteEmployer(data.employer.id);
                        response.then(res => {
                            if (res.ok) {
                                events.navigateback();
                            } else {
                                setErrorMessage(res.statusText);
                            }
                        });
                    }
                },
                {
                    label: t("No"),
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
        };
        confirmAlert(options);
    };


    return (
        <>

            <form className="form" autoComplete="off" >
                <div className='formCollapse'>
                    <label className='formtitle'>
                        {t('Employerdetails')} '{data.employer.Naam}'
                    </label>

                </div>
                <div id="formcontent" className='bggreen'>
                    <br></br>

                    <div className="groupbox">
                        <label className='formtitleGroupBox'> {t('Algemeen')}</label>
                        <div className="formchild" style={rights !== 2 ? { display: "none" } : null}>
                            <label className='labelhotel'>
                                {t('Active')}:
                            </label>
                            <input id="userActive" type='checkBox' className="checkbox" value={data.employer.active} name="actief" onChange={events.changecheckbox} checked={data.employer.active} disabled={isDisabled}></input>

                        </div>
                        <div className="formchild">
                            <label className='labelhotel'>
                                {t('Naam')}:
                            </label>
                            <input id='Naam' type='text' name="Naam" value={data.employer.Naam} onChange={events.changevalue} disabled={isDisabled} className="normalinput"></input>
                            <label className='labelhotel'>
                                {t('Street')}:
                            </label>
                            <input id="straatnaam" type='text' required name="straatnaam" value={data.employer.straatnaam} onChange={events.changevalue} disabled={isDisabled} className="normalinput"></input>

                            <label className='labelhotel'>
                                {t('BTWnr')}:
                            </label>
                            <input id="btw" required type='text' name="btw_nummer" value={data.employer.btw_nummer} onChange={events.changevalue} disabled={isDisabled} className="normalinput" ></input>

                            <label className='labelhotel'>
                                {t('Nr')}:
                            </label>
                            <input id="huisnummer" type='text' required name="huisnummer" value={data.employer.huisnummer} onChange={events.changevalue} disabled={isDisabled} className="normalinput" ></input>

                            <label className='labelhotel'>
                                {t('Postbus')}:
                            </label>
                            <input id="bus" type='text' required name="bus" value={data.employer.bus} onChange={events.changevalue} disabled={isDisabled} className="normalinput" ></input>

                            <label className='labelhotel'>
                                {t('ZipCode')}:
                            </label>
                            <input id="zipcode" type='text' required name="zipcode" value={data.employer.zipcode} onChange={events.changevalue} disabled={isDisabled} className="normalinput"  ></input>

                            <label className='labelhotel'>
                                {t('Community')}:
                            </label>
                            <input id="gemeente" type='text' required name="gemeente" value={data.employer.gemeente} onChange={events.changevalue} disabled={isDisabled} className="normalinput"  ></input>

                            <label className='labelhotel'>
                                {t('Contactnummer')}:
                            </label>
                            <input id="contactnumber" type='text' required name="contactnumber" value={data.employer.contactnumber} onChange={events.changevalue} disabled={isDisabled} className="normalinput" ></input>
                            <label className='labelhotel'>
                                {t('contactperson')}:
                            </label>
                            <input id="contactperson" type='text' required name="contactperson" value={data.employer.contactperson} onChange={events.changevalue} disabled={isDisabled} className="normalinput" ></input>
                            <label className='labelhotel'>
                                {t('email')}:
                            </label>
                            <input id="email" type='text' required name="email" value={data.employer.email} onChange={events.changevalue} disabled={isDisabled} className="normalinput" ></input>
                        </div>
                    </div>
                    <div className="groupbox">
                        <div className="formchild">
                            <label className='formtitleGroupBox'> {t('Uurtarieven')}</label>
                            <label className='labelhotel'>
                                {t('weektarief')}:
                            </label>
                            <CurrencyInput
                                id="weektarief"
                                name="weektarief"
                                value={data.employer.weektarief}
                                placeholder="Please enter a number"
                                defaultValue={0.00}
                                decimalsLimit={2}
                                decimalSeparator="."
                                groupSeparator=","
                                onChange={events.changevalue}
                                disabled={isDisabled}
                            />
                            <label className='labelhotel'>
                                {t('zaterdagtarief')}:
                            </label>
                            <CurrencyInput
                                id="zaterdagtarief"
                                name="zaterdagtarief"
                                value={data.employer.zaterdagtarief}
                                placeholder="Please enter a number"
                                defaultValue={0.00}
                                decimalsLimit={2}
                                decimalSeparator="."
                                groupSeparator=","
                                onChange={events.changevalue}
                                disabled={isDisabled}
                            />
                            <label className='labelhotel'>
                                {t('zon_feestdagtarief')}:
                            </label>
                            <CurrencyInput
                                id="zon_feestdagtarief"
                                name="zon_feestdagtarief"
                                value={data.employer.zon_feestdagtarief}
                                placeholder="Please enter a number"
                                defaultValue={0.00}
                                decimalsLimit={2}
                                decimalSeparator="."
                                groupSeparator=","
                                onChange={events.changevalue}
                                disabled={isDisabled}
                                //className="normalinput"
                            />
                        </div>
                    </div>
                    <br></br>
                </div>
                <div id="editDiv" className="formchildButton" style={rights !== 2 & rights !== 4 ? { display: "none" } : null}>
                    <Button id="editButton" className='' style={rights !== 2 & rights !== 4 ? { display: "none" } : null} onClick={events.handleEdit}>{t('Edit')}</Button>
                </div>

                <div id="saveDiv" class="two_Buttons" style={rights !== 2 & rights !== 4 ? { display: "none" } : null}>
                    <Button type="button" id="saveButton" className="Savebutton btn btn-primary margin-right" onClick={events.onSubmit}> {t('Save')}</Button>
                    <Button type="button" id="cancelButton" className="Savebutton btn btn-primary margin-right" onClick={events.handleCancel} >{t('Cancel')}</Button>
                </div>

            </form>
        </>
    );
}


export default EmployeeNode;
